import React from 'react';
import PropTypes from 'prop-types';

import { PowerFunnelSurfaces } from '../../Analytics/constants';
import useIsMobile from '../../hooks/useIsMobile';
import useGlobalPrivilegesCta from '../../hooks/useGlobalPrivilegesCta';
import styles from './tennisPassportBanner.scss';

const TennisPassportBanner = ({ surface = PowerFunnelSurfaces.HOME, variant = 'tennis_passport' }) => {
    const { isMobileWidth } = useIsMobile();
    const {
        buttonText,
        hasPastDueSubscription,
        pastDueSubscriptionMessage,
        handleCtaClick,
        handleLearnMoreClick,
    } = useGlobalPrivilegesCta({ surface, variant, trackImpressions: true });

    return (
        <div className={styles.tennisPassportBanner}>
            <div className={styles.bannerInner}>
                <div className={styles.contentSection}>
                    <p className={styles.headline} data-testid="banners.tennis-passport.headline">
                        Your Tennis Passport is Waiting.
                    </p>
                    <p className={styles.subhead} data-testid="banners.tennis-passport.subhead">
                        Upgrade to Power and get $250 in travel value instantly.
                    </p>
                    <p className={styles.body} data-testid="banners.tennis-passport.body">
                        From court-side at world-class resorts to airport lounge access,
                        this membership pays for itself before you even swing a racket.
                    </p>
                    {hasPastDueSubscription && <p className={styles.pastDueMessage} data-testid="banners.tennis-passport.past-due-message">{pastDueSubscriptionMessage}</p>}
                    <button
                        className={styles.ctaButton}
                        onClick={handleCtaClick}
                        type="button"
                        data-testid="banners.tennis-passport.cta-btn"
                    >
                        {buttonText}
                    </button>
                    <div
                        className={styles.learnMore}
                        onClick={handleLearnMoreClick}
                        data-testid="banners.tennis-passport.learn-more"
                    >
                        <span className={styles.underline} data-testid="banners.tennis-passport.learn-more-link">Learn more</span>
                        {' about '}
                        <img
                            src="/img/v3/graphics/perks/global-privileges/global-privileges-logo.png"
                            alt="Global Privileges"
                            className={styles.gpLogo}
                        />
                    </div>
                </div>
                <div className={styles.imageSection}>
                    <img
                        src={isMobileWidth
                            ? '/img/v3/graphics/perks/global-privileges/tennis-passport-mobile.png'
                            : '/img/v3/graphics/perks/global-privileges/tennis-passport.png'}
                        alt="Man with tennis bag at airport gate"
                        className={styles.bannerImage}
                    />
                </div>
            </div>
        </div>
    );
};

TennisPassportBanner.propTypes = {
    surface: PropTypes.oneOf([PowerFunnelSurfaces.HOME, PowerFunnelSurfaces.POWER_PERKS_PAGE]),
    variant: PropTypes.string,
};

TennisPassportBanner.defaultProps = {
    surface: PowerFunnelSurfaces.HOME,
    variant: 'tennis_passport',
};

export default TennisPassportBanner;
